// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__hFMIW","rootSmall":"AddTileButton_rootSmall__1nky7"};